module.exports = __webpack_public_path__ + "static/img/home-feature.8cb4bed.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-feature.png
// module id = YoEh
// module chunks = 1